export default __webpack_public_path__ + "static/media/SE_Life.477d5dda.png";